export function hasAbility(state) {
  return (ability) => {
    return _.indexOf(state.user.abilities, ability) > -1
  }
}